/* Carrusel de unidades destacadas — Vendotractos.
 *
 * Hace tres cosas, en este orden:
 *
 * 1. Baraja las tarjetas. El script se carga SIN defer, justo despues de la
 *    cinta, asi que corre mientras la pagina se sigue armando: el navegador
 *    nunca llega a pintar el orden original y no se ve un salto. Cada carga
 *    de pagina —entrar, volver con el boton de atras, recargar— reordena.
 * 2. Elige uno de los dos ganchos de venta al azar.
 * 3. Conecta las flechas. El desplazamiento con el dedo ya lo da el scroll
 *    nativo con scroll-snap; las flechas solo mueven la cinta un "ancho de
 *    vista" y se apagan cuando ya no hay para donde ir.
 */
(function () {
  'use strict';

  // Fisher-Yates. Se reordenan los nodos en su sitio, sin volver a crearlos:
  // las fotos ya en cache no se vuelven a pedir.
  function barajar(pista) {
    var tarjetas = Array.prototype.slice.call(pista.children);
    for (var i = tarjetas.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = tarjetas[i];
      tarjetas[i] = tarjetas[j];
      tarjetas[j] = temp;
    }
    var cinta = document.createDocumentFragment();
    tarjetas.forEach(function (tarjeta) {
      cinta.appendChild(tarjeta);
    });
    pista.appendChild(cinta);
  }

  function rotarGancho(seccion) {
    var ganchos = seccion.querySelectorAll('[data-vt-gancho]');
    if (ganchos.length < 2) return;
    var elegido = Math.floor(Math.random() * ganchos.length);
    ganchos.forEach(function (gancho, indice) {
      gancho.hidden = indice !== elegido;
    });
  }

  function conectar(carrusel) {
    var pista = carrusel.querySelector('[data-vt-pista]');
    if (!pista) return;

    var anterior = carrusel.querySelector('[data-vt-anterior]');
    var siguiente = carrusel.querySelector('[data-vt-siguiente]');

    function paso() {
      // Un "salto" es lo que se ve, menos una tarjeta, para no perder el hilo.
      var tarjeta = pista.querySelector('.vt-cat');
      if (!tarjeta) return pista.clientWidth;
      var ancho = tarjeta.getBoundingClientRect().width;
      var caben = Math.max(1, Math.round(pista.clientWidth / ancho));
      var salto = caben > 1 ? caben - 1 : 1;
      return ancho * salto;
    }

    function refrescar() {
      // 2px de tolerancia: el scroll fraccionario nunca cae en el numero exacto.
      var tope = pista.scrollWidth - pista.clientWidth - 2;
      if (anterior) anterior.disabled = pista.scrollLeft <= 2;
      if (siguiente) siguiente.disabled = pista.scrollLeft >= tope;
    }

    if (anterior) {
      anterior.addEventListener('click', function () {
        pista.scrollBy({ left: -paso(), behavior: 'smooth' });
      });
    }

    if (siguiente) {
      siguiente.addEventListener('click', function () {
        pista.scrollBy({ left: paso(), behavior: 'smooth' });
      });
    }

    pista.addEventListener('scroll', refrescar, { passive: true });
    window.addEventListener('resize', refrescar);

    // El script corre mientras la pagina se arma: en ese momento la cinta
    // todavia no tiene medidas y las flechas saldrian apagadas. Se vuelve a
    // medir cuando ya hay layout y otra vez cuando cargan las fotos.
    requestAnimationFrame(refrescar);
    window.addEventListener('load', refrescar);
    refrescar();
  }

  function arrancar() {
    document.querySelectorAll('[data-vt-carrusel]').forEach(function (carrusel) {
      if (carrusel.dataset.vtListo === '1') return;
      carrusel.dataset.vtListo = '1';

      var pista = carrusel.querySelector('[data-vt-pista]');
      if (pista) barajar(pista);

      var seccion = carrusel.closest('.vt-seccion') || document;
      rotarGancho(seccion);

      conectar(carrusel);
    });
  }

  arrancar();

  // El editor de temas recarga la seccion sin recargar la pagina.
  document.addEventListener('shopify:section:load', arrancar);
})();
